import { db } from "./firebase";
import moment from "moment";
import {
  getWeekNumber,
} from "../services";
import { dateConfig, TRANSFER, LAST, SET_EMPTY } from "../pages/Punch/config";
export const fetchTotalHoursOfWorker = (workerId, week) => {
  let weekNumber = getWeekNumber(week);
  const id = `${weekNumber}-${workerId}`;
  console.log("this is week ", moment(week).year());
  console.log("this is id ", id);
  return new Promise((res, rej) => {
    db.collection("timesheets")
      .doc(id)
      .get()
      .then((document) => {
        res(document.data());
      })
      .catch((error) => {
        rej(error);
      });
  });
};

 

export const fetchWorkerDetails = async (workers, week) => {
  if (!Array.isArray(workers)) {
    return [];
  }
  const promises = workers.map((worker) => {
    return fetchTotalHoursOfWorker(worker.workerId, week);
  });

  return Promise.allSettled(promises);
};
